<template>
  <div class="admin-program__edit-container" >
    <div v-if="category">
      <fieldset>
        <label>Name</label>
        <input type="text" v-model="category.name" />
      </fieldset>

      <a class="admin-program__delete-link" @click="delete__clicked">Delete</a>

    </div>
  </div>
</template>


<script>


import router from "../../../router/router";

export default {
  computed:{
    program_id(){
      return this.$route.params.id;
    },
    section_index(){
      return parseInt(this.$route.params.section_index);
    },
    category_index(){
      return parseInt(this.$route.params.category_index);
    },
    structure(){
      return this.$parent.structure;
    },
    category(){
      return this.structure !== null && this.structure !== undefined
              && this.section_index < this.structure.sections.length
              && this.category_index < this.structure.sections[this.section_index].categories.length ?
          this.structure.sections[this.section_index].categories[this.category_index] :
          null;
    }
  },
  methods:{
    async delete__clicked(){
      if(this.category && this.category.contents.length > 0){
        alert("All content items in this category must be deleted before deletion of category possible.")
      }else if(this.category){
        this.structure.sections[this.section_index].categories.splice(this.category_index, 1);
        router.push( `/admin/programs/${this.program_id}`);
      }
    },
  }
}
</script>